import Stepper, { StepperProps } from './Stepper';

export type { StepperProps };
export default Stepper;
